import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import * as actions from "./actions";

function* fetchCrystalAvailability() {
  try {
    const result = yield call(AxiosCall, `/crystals/get_availability/`);
    yield put(actions.fetchCrystalAvailabilitySuccess(result.data.available));
  } catch (e) {
    yield put(actions.fetchCrystalAvailabilityFailure(e));
  }
}

function* fetchCrystalQuestionnaire() {
  try {
    const result = yield call(AxiosCall, `/crystals/get_questionnaire/`);
    const { results } = result.data;
    yield put(actions.fetchCrystalQuestionnaireSuccess(results));
  } catch (e) {
    yield put(actions.fetchCrystalQuestionnaireFailure(e));
  }
}

function* submitCrystalQuestionnaire(action) {
  try {
    const result = yield call(AxiosPost, `/crystals/submit_questionnaire/`, action.payload);
    const reading = result.data.results?.at(0);
    if (!reading) {
      const response = result.data.response;
      if (response === "CRYSTAL_READING_CONSUMED") {
        throw new Error("Ya realizaste tu consulta diaria de Cristales");
      }
      throw new Error("Error al procesar el cuestionario");
    }
    yield put(actions.submitCrystalQuestionnaireSuccess(reading));
  } catch (e) {
    yield put(actions.submitCrystalQuestionnaireFailure(e));
  }
}

function* fetchAllCrystals() {
  try {
    const result = yield call(AxiosCall, `/crystals/get_crystals/`);
    const { results } = result.data;
    yield put(actions.fetchAllCrystalsSuccess(results));
  } catch (e) {
    yield put(actions.fetchAllCrystalsFailure(e));
  }
}

function* captureCrystalLead(action) {
  try {
    yield call(AxiosPost, `/marketing/capture_lead/`, action.payload);
    yield put(actions.captureCrystalLeadSuccess());
  } catch (e) {
    yield put(actions.captureCrystalLeadFailure(e));
  }
}

function* setCrystalReadingLike(action) {
  try {
    yield call(AxiosPost, `/crystals/set_reading_like/`, action.payload);
    yield put(actions.setCrystalReadingLikeSuccess());
  } catch (e) {
    yield put(actions.setCrystalReadingLikeFailure(e));
  }
}

function* sendCrystalReadingEmail(action) {
  try {
    yield call(AxiosPost, `/crystals/send_free_reading/`, action.payload);
    yield put(actions.sendCrystalReadingEmailSuccess());
  } catch (e) {
    yield put(actions.sendCrystalReadingEmailFailure(e));
  }
}

export default function* crystalsSaga() {
  yield all([
    takeLatest(actions.FETCH_CRYSTAL_AVAILABILITY_REQUEST, fetchCrystalAvailability),
    takeLatest(actions.FETCH_CRYSTAL_QUESTIONNAIRE_REQUEST, fetchCrystalQuestionnaire),
    takeLatest(actions.FETCH_ALL_CRYSTALS_REQUEST, fetchAllCrystals),
    takeLatest(actions.SUBMIT_CRYSTAL_QUESTIONNAIRE_REQUEST, submitCrystalQuestionnaire),
    takeLatest(actions.SET_CRYSTAL_READING_LIKE_REQUEST, setCrystalReadingLike),
    takeLatest(actions.CAPTURE_CRYSTAL_LEAD_REQUEST, captureCrystalLead),
    takeLatest(actions.SEND_CRYSTAL_READING_EMAIL_REQUEST, sendCrystalReadingEmail),
  ]);
}
